import React from "react";
import {Alert} from "@mui/material";
import Button from "@mui/material/Button";
import {useTranslation} from "react-i18next";
import {useOutdatedPermissions} from "../../technical/rest/AxiosProvider";
import {useUserManager} from "../../technical/auth/UserManagerContext";

/**
 * Shown when the permissions of the access token are outdated, e.g. after the roles of the current user were changed.
 * Lists would be empty or incomplete until the user signs in again (SSO-292).
 */
export function OutdatedPermissionsAlert() {
  const {t} = useTranslation();
  const outdatedPermissions = useOutdatedPermissions();
  const userManager = useUserManager();

  if (!outdatedPermissions) {
    return <></>
  }
  return (
    <Alert severity={'warning'} sx={{marginBottom: 2}} action={
      <Button color={'inherit'} size={'small'} onClick={() => userManager.removeUser().then(() => window.location.reload())}>
        {t('OutdatedPermissions.button')}
      </Button>
    }>
      {t('OutdatedPermissions.message')}
    </Alert>
  )
}
